import React from "react";
import { Popconfirm } from "antd";

/**
 * Popover component for displaying all offer codes for a Marketing SKU
 * @param {Array} offerCodes - Array of offer codes to display
 * @param {ReactNode} children - Trigger element for the popover
 * @param {string} title - Title for the popover
 */
const OfferCodesPopover = ({ offerCodes, children, title }) => {
  const popoverContent = (
    <div style={{ maxWidth: "300px", maxHeight: "300px", overflowY: "auto" }}>
      {offerCodes && offerCodes.length > 0 ? (
        <div>
          <p style={{ marginBottom: "12px", color: "#666", fontSize: "12px" }}>
            Total: {offerCodes.length} offer code(s)
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {offerCodes.map((code, index) => (
              <div
                key={index}
                style={{
                  padding: "6px 8px",
                  backgroundColor: "#f0f8ff",
                  border: "1px solid #d6f2ff",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}>
                <span style={{ fontWeight: "500" }}>{code}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "12px", color: "#999", fontSize: "12px" }}>
          No offer codes found
        </div>
      )}
    </div>
  );

  return (
    <Popconfirm
      title={title}
      description={popoverContent}
      icon={null}
      showCancel={false}
      okText="Close"
      placement="left"
      overlayStyle={{ maxWidth: "350px" }}>
      {children}
    </Popconfirm>
  );
};

export default OfferCodesPopover;
